import React from "react";
import { useTranslation } from "react-i18next";

function VoiceMailACD({ register, errors, setValue }) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="margin-top huntgroup">
        <div className="general-settings">{t("Voicemail")}</div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("Pin")}</div>
          <div className="w-30">
            <input type="text" value="7558" className="selectname w-100" />
          </div>
        </div>

        <div className="add-numbermain add-numbermain-small align-items-start">
          <div>
            <div className="tel-numbers">{t("unavaliableGreeting")}</div>
          </div>
          <div className="phoneselect width-100">
            <audio controls className="audio-controls"></audio>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span
                className="routing-edit"
                data-bs-toggle="modal"
                data-bs-target="#medialibrary-tabs"
              >
                {t("edit")}
              </span>
            </div>
          </div>
        </div>

        <div className="add-numbermain add-numbermain-small align-items-start">
          <div>
            <div className="tel-numbers">{t("busyGreeting")}</div>
          </div>
          <div className="phoneselect width-100">
            <audio controls className="audio-controls"></audio>
            <div className="routing-per">
              <span>{t("personalized")}</span>
              <span
                className="routing-edit"
                data-bs-toggle="modal"
                data-bs-target="#medialibrary-tabs"
              >
                {t("edit")}
              </span>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("play_Mess_timestamp")}
            <br />
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input className="form-control" type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("include_Transcript")}
            <br />
            <span className="phrecording text-secondary">
                  {t("vmail_copy_trans_text")}
                </span>
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input className="form-control" type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("email_notif")}
            <br />
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input className="form-control" type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("email_address")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input
                type="text"
                placeholder="Enter Email Address"
                className="selectname w-100"
              />
              <p className="mt-2">
                Include Users and supervisors
                <input
                  type="checkbox"
                  value="Include Users and Supervisors"
                  className="ms-2"
                  checked
                />
              </p>
            </div>
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("del_send_message")}
            <br />
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input className="form-control" type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

       

        <div className="add-numbermain">
          <div className="tel-numbers">
            {t("boardcast_voicemails")}
            <br />
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input className="form-control" type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VoiceMailACD;
